import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _IconStarTrekColor from './icon-star-trek-color.vue';

const IconStarTrekColor = Object.assign(_IconStarTrekColor, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _IconStarTrekColor.name, _IconStarTrekColor);
  }
});

export default IconStarTrekColor;
